module.exports = __webpack_public_path__ + "static/img/14.31a466b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/14.jpg
// module id = h2GI
// module chunks = 1